import React from 'react';

import { Table, TableColumnDef } from '@klp/design/Table';

import type { Bygg } from '../../classes';

interface IByggTableProps {
    byggList: Array<Bygg>;
    search: string;
    onByggSelect: (bygg: Bygg) => void;
}

export const ByggTable: React.FC<IByggTableProps> = ({
    byggList,
    search,
    onByggSelect,
}) => {
    const columns = [
        new TableColumnDef({
            translation: 'bygg.byggNummer',
            key: 'byggNummer',
            sortable: true,
            align: 'left',
        }),
        new TableColumnDef({
            translation: 'bygg.name',
            key: 'navn',
            sortable: true,
            align: 'left',
        }),
        new TableColumnDef({
            translation: 'bygg.adresse',
            key: 'adresse',
            sortable: true,
            align: 'left',
        }),
    ];

    return (
        <Table<Bygg, unknown>
            id="ByggList"
            data={byggList}
            columns={columns}
            onRowSelect={onByggSelect}
            highlightPhrase={search}
            sortBy={columns[0]}
            sortByDirection="asc"
        />
    );
};
